import React from 'react';
import PropTypes from 'prop-types';
// Styles
import { Wrapper } from './StatusMessage.styles';

const StatusMessage = ({ glyph, title, children, action }) => (
  <Wrapper>
    <div className='glyph' aria-hidden='true'>
      {glyph}
    </div>
    <h2>{title}</h2>
    {children && <p>{children}</p>}
    {action}
  </Wrapper>
);

StatusMessage.propTypes = {
  glyph: PropTypes.node,
  title: PropTypes.string,
  action: PropTypes.node
};

export default StatusMessage;
